export default __webpack_public_path__ + "static/mediaBGBottom-52772f6d82fc1f1bb40ab07db511bbda.jpg";